export function getdata() {
	var obj = {
		searchlist: [{
				prop: "companyCode",
				label: '公司代码',
				type: "input"
			},
			{
				prop: "companyName",
				label: '公司名称',
				type: "input"
			},
			{
				prop: "startBalanceDebit",
				label: '期初余额（借方）',
				type: "inputplus"
			},
			{
				prop: "startBalanceCredit",
				label: '期初余额（贷方）',
				type: "inputplus"
			},
			{
				prop: "currentBalanceDebig",
				label: '本期发生额（借方）',
				type: "inputplus"
			},
			{
				prop: "endBalanceDebig",
				label: '期末发生额（借方）',
				type: "inputplus"
			},
			{
				prop: "period",
				label: '税款所属期间',
				type: "datemonth",
				valueformat: 'yyyyMM'
			},
		],
		tableData: [{
				companyNo: "A00191310115MA1K3R189Q",
				fapdm: "1.1001800305E10",
				goufmc: "上海速元科技有限公司",
				jinge: "111.0",
				piaojzs: "1",
				shenbq: "202207",
				shuie: "0.0"
			},
			{
				companyNo: "A001123456789",
				fapdm: "11001800305",
				goufmc: "上海速元科技有限公司",
				jinge: "647.2",
				piaojzs: "6",
				shenbq: "202207",
				shuie: "8.999999999999998",
			}
		],
		searchdata: {
			shenbq: "",
		},
		headData: [{
				title: "公司名称",
				prop: "goufmc",
				width: 160,
				align: "left"
			},
			{
				title: "进项税额类型",
				prop: "jinjzs",
				width: 100
			},
			{
				title: "份数",
				prop: "piaojzs",
				// custom:true
				width: 80,
				AmountFormat: true,
				align: "right"
			},
			{
				title: "金额",
				prop: "jinge",
				width: 80,
				AmountFormat: true,
				align: "right"
			},
			{
				title: "税额",
				prop: "shuie",
				width: 80,
				AmountFormat: true,
				align: "right"
			},
		],
		outputData: {
			exportType: "",
			shenbq: "",
		},
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		}
	}
	return obj
}
